export enum RenewalState {
  SUBSCRIPTION_RENEWAL_PENDING = 'SUBSCRIPTION_RENEWAL_PENDING',
  SUBSCRIPTION_RENEWAL_CONFIRMED = 'SUBSCRIPTION_RENEWAL_CONFIRMED',
}
